export default [
  {
    path:'/admin/problem/list',
    name: 'ProblemList',
    component: () => import('@/views/problem/list'),
    meta:{
      title:'健康评测-问卷分类',
      keepAlive:false
    }
  },
  {
    path:'/admin/problem/info',
    name: 'ProblemInfo',
    component: () => import('@/views/problem/info'),
    meta:{
      title:'健康评测-问卷信息',
      keepAlive:false
    }
  },
  {
    path:'/admin/problem/record',
    name: 'ProblemRecord',
    component: () => import('@/views/problem/record'),
    meta:{
      title:'健康评测-答题记录',
      keepAlive:false
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/problem.js